import dayjs from "dayjs";

const AgentReviewFormConversions:any = {
    agentID: {
        display: "Agent ID",
    },
    address1: {
        display: "Address",
    },
    address2: {
        display: "Address 2",
    },
    telephone1: {
        display: "Telephone 1",
    },
    telephone2: {
        display: "Telephone 2",
    },
    url: {
        display: "URL",
    },
    applicationCompletedAndSubmittedDate: {
        display: "Completed & Submitted On",
        render: (date:string) => date ? dayjs(date).format("MMM DD, YYYY") : "N/A"
    },
    applicationApprovedByAGLDate: {
        display: "Approved On",
        render: (date:string) => date ? dayjs(date).format("MMM DD, YYYY") : "N/A"
    },
    applicationDeniedByAGLDate: {
        display: "Denied On",
        render: (date:string) => date ? dayjs(date).format("MMM DD, YYYY") : "N/A"
    },
    createDate: {
        display: "Created On",
        render: (date:string) => date ? dayjs(date).format("MMM DD, YYYY") : "N/A"
    },
    asOfDate: {
        display: "As Of",
        render: (date:string) => date ? dayjs(date).format("MMM DD, YYYY") : "N/A"
    },
    welcomeEmailSentToAgentDate: {
        display: "Welcome Sent",
        render: (sent:boolean|null) => sent ? "Yes" : "No"
    },
}

export const AgentReviewFormExclusions = ["formPassword"]

export default AgentReviewFormConversions;